import React from 'react';
export function TaglineSection() {
  return <section className="bg-sure-black w-full py-24 md:py-32" data-id="element-206">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 text-center" data-id="element-207">
        <h2 className="text-sure-white text-2xl md:text-3xl lg:text-4xl font-light italic leading-relaxed max-w-4xl mx-auto" data-id="element-208">
          "Activates existing infrastructure into a continuous, decision-grade
          intelligence capability."
        </h2>
      </div>
    </section>;
}